import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m4 15.56a1 1 0 0 1-1.55.84l-2.56-1.71a.27.27 0 0 0-.26 0 .25.25 0 0 0-.13.22v.54a1 1 0 0 1-1.63.78l-4.21-3.46a1 1 0 0 1 0-1.55l4.21-3.44a1 1 0 0 1 1.63.77v.55a.26.26 0 0 0 .13.22.27.27 0 0 0 .26 0l2.56-1.72a1 1 0 0 1 1.55.83Z"
    }, null, -1)
  ]));
}
const entertainmentControlButtonCircleLeftArrowRewind = { render };
export {
  entertainmentControlButtonCircleLeftArrowRewind as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-left-arrow-rewind.svg.js.map
